import { render, staticRenderFns } from "./AdminTravelServiceAddBookingView.vue?vue&type=template&id=4ae760a8&"
import script from "./AdminTravelServiceAddBookingView.vue?vue&type=script&lang=js&"
export * from "./AdminTravelServiceAddBookingView.vue?vue&type=script&lang=js&"
import style0 from "./AdminTravelServiceAddBookingView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCol,VForm,VIcon,VRow,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae760a8')) {
      api.createRecord('4ae760a8', component.options)
    } else {
      api.reload('4ae760a8', component.options)
    }
    module.hot.accept("./AdminTravelServiceAddBookingView.vue?vue&type=template&id=4ae760a8&", function () {
      api.rerender('4ae760a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/travel-service/AdminTravelServiceAddBookingView.vue"
export default component.exports